import { duyuruSekmesi } from "../components/announcements.js";
import { duyuruOzeti } from "../domain/announcements.js";
import { B, cls, stu } from "../domain/context.js";
import { avatar } from "../lib/avatar.js";
import { card, emptyNote } from "../components/ui.js";
import { esc } from "../lib/fmt.js";
import { state } from "../state.js";

// ---------- MESAJLAR ----------
export function viewMesajlar() {
  const aktif = state.mesajTab ?? "yazismalar";
  const ozet = duyuruOzeti(B().id);
  const sekmeler = `
  <div class="flex items-center gap-1 rounded-xl bg-line/50 p-1 mb-4 w-fit">
    ${[["yazismalar", "Yazışmalar"], ["duyurular", `Duyurular${ozet.yanitBekleyen ? ` · ${ozet.yanitBekleyen}` : ""}`]]
      .map(([id, label]) => `
      <button data-mesajtab="${id}"
        class="rounded-lg px-3 py-1.5 text-xs font-semibold whitespace-nowrap transition ${aktif === id ? "bg-white shadow-card" : "text-inksoft hover:text-ink"}">
        ${label}
      </button>`).join("")}
  </div>`;

  if (aktif === "duyurular") return sekmeler + duyuruSekmesi(B().id);
  return sekmeler + yazismaGorunumu();
}

function yazismaGorunumu() {
  const t = B();
  const active = t.messages.find(m => m.id === state.activeThread) ?? t.messages[0];
  return `
  <div class="grid gap-4 lg:grid-cols-[320px,1fr]">
    ${card(`
      <div class="divide-y divide-line/70">
        ${t.messages.map(m => {
          const s = stu(m.studentId);
          return `<button data-thread="${m.id}" class="w-full flex items-start gap-3 p-4 text-left hover:bg-paper/60 ${active?.id === m.id ? "bg-paper" : ""}">
            ${avatar(s)}
            <span class="min-w-0 flex-1">
              <span class="flex items-center justify-between">
                <span class="text-sm font-semibold truncate">${esc(m.parent)}</span>
                <span class="text-[10px] text-inksoft shrink-0 ml-2">${m.time}</span>
              </span>
              <span class="block text-[11px] text-inksoft">${esc(s.name)} · ${esc(cls(s.classId).name)}</span>
              <span class="block text-xs text-inksoft/90 truncate mt-0.5">${esc(m.preview)}</span>
            </span>
            ${m.unread ? `<span class="w-2 h-2 rounded-full bg-coral mt-1.5 shrink-0"></span>` : ""}
          </button>`;
        }).join("") || emptyNote("Mesaj yok.")}
      </div>`, "min-w-0 overflow-hidden self-start")}

    ${active ? card(`
      <div class="p-4 border-b border-line flex items-center gap-3">
        ${avatar(stu(active.studentId), "w-10 h-10 text-sm")}
        <div>
          <div class="font-semibold text-sm">${esc(active.parent)}</div>
          <div class="text-[11px] text-inksoft">${esc(stu(active.studentId).name)} hakkında</div>
        </div>
      </div>
      <div class="p-4 space-y-3 min-h-[280px]">
        ${active.thread.map(msg => `
          <div class="flex ${msg.from === "kurum" ? "justify-end" : ""}">
            <div class="max-w-[85%] rounded-2xl px-4 py-2.5 text-sm ${msg.from === "kurum" ? "bg-teal text-white rounded-br-md" : "bg-paper rounded-bl-md"}">
              ${esc(msg.text)}
              <div class="text-[10px] mt-1 ${msg.from === "kurum" ? "text-white/70" : "text-inksoft/70"}">${msg.time}</div>
            </div>
          </div>`).join("")}
      </div>
      <div class="p-4 border-t border-line flex gap-2">
        <input id="msgInput" placeholder="Yanıt yazın…" class="flex-1 rounded-xl border border-line bg-paper/60 px-4 py-2.5 text-sm" />
        <button id="msgSend" class="rounded-xl bg-teal text-white font-semibold text-sm px-5 hover:opacity-90">Gönder</button>
      </div>`, "min-w-0 overflow-hidden flex flex-col") : ""}
  </div>`;
}

